import { useEquipeIncompletaDialog } from "./use-equipe-incompleta-dialog";
import { EquipeIncompletaDialogView } from "./view-equipe-incompleta-dialog";
import type { EquipeIncompletaDialogProps } from "./types-equipe-incompleta-dialog";

export function EquipeIncompletaDialog(props: EquipeIncompletaDialogProps) {
  const vm = useEquipeIncompletaDialog(props);

  return <EquipeIncompletaDialogView {...props} {...vm} />;
}

export type * from "./types-equipe-incompleta-dialog";
